import type { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_ROUTE_NAME } from '@/consts';

// The check-in flow's strings live in the GLOBAL bundle (src/i18n/*/checkin.ts) because the
// flow (CheckinFlow / ListAppointments / VerifyEditAppointment) is reused off-route — e.g. the
// customer-mgmt-v2 dialog. A route-scoped bundle would render raw keys there, so this screen
// declares no `meta.i18n`.
export const customerCheckinRoutes: RouteRecordRaw = {
  path: '/customer-checkin',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true },
  children: [
    {
      path: '',
      name: CUSTOMER_ROUTE_NAME.CUSTOMER_CHECKIN,
      component: () => import('./CustomerCheckin.vue'),
    },
  ],
};

export const customerCheckinRedirects: RouteRecordRaw[] = [
  { path: '/customer-checkin/create', redirect: { name: CUSTOMER_ROUTE_NAME.CUSTOMER_CHECKIN } },
];
